import BreadCrumb from "../screens/MobileCommon/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/Mobilelayout/admin-dashboard";
import DocumentProfile from "../screens/MobileInfoView/DocumentProfile";

const breadCrumbData = [
  { link: "/view-info-list", name: "Info List" },
  { link: "/view-info-detail", name: "Info Details" }
];

const Users = () => (
  <>
    <LayoutContainer>
      {/* <BreadCrumb data={breadCrumbData} /> */}
      <DocumentProfile />
    </LayoutContainer>
  </>
);

export default Users;
